import cookies from './cookies'
import 'url-polyfill'

export default {
  // Mixins
  mixins: [cookies],

  // Data
  data () {
    return {
      marketingCloud_expireDays: 90,
      marketingCloud_linkAlias: 'thanks',
      marketingCloud_conversionLinkID: '123457',
      marketingCloud_displayOrder: '1',
      marketingCloud_dataset: '<data amt="1" unit="Downloads" accumulate="true" />',
      marketingCloud_values: {
        'sfmc_sub': 'SubscriberID',
        'j': 'JobID',
        'l': 'ListID',
        'u': 'UrlID',
        'mid': 'MemberID',
        'jb': 'BatchID'
      }
    }
  },

  // Computed
  computed: {
    $_marketingCloud_jobID () {
      return this.$_cookies_getItem('JobID') || ''
    },
    $_marketingCloud_memberID () {
      return this.$_cookies_getItem('MemberID') || ''
    },
    $_marketingCloud_subscriberID () {
      return this.$_cookies_getItem('SubscriberID') || ''
    },
    $_marketingCloud_listID () {
      return this.$_cookies_getItem('ListID') || ''
    },
    $_marketingCloud_urlID () {
      return this.$_cookies_getItem('UrlID') || ''
    },
    $_marketingCloud_batchID () {
      return this.$_cookies_getItem('BatchID') || ''
    },
    $_marketingCloud_pixelSrc () {
      return `//click.s7.exacttarget.com/conversion.aspx?xml=
      <system>
        <system_name>tracking</system_name>
        <action>conversion</action>
        <member_id>${this.$_marketingCloud_memberID}</member_id>
        <job_id>${this.$_marketingCloud_jobID}</job_id>
        <email></email>
        <sub_id>${this.$_marketingCloud_subscriberID}</sub_id>
        <list>${this.$_marketingCloud_listID}</list>
        <original_link_id>${this.$_marketingCloud_urlID}</original_link_id>
        <conversion_link_id>${this.marketingCloud_conversionLinkID}</conversion_link_id>
        <display_order>${this.marketingCloud_displayOrder}</display_order>
        <link_alias>${this.marketingCloud_linkAlias}</link_alias>
        <data_set></data_set>
        <BatchID>${this.$_marketingCloud_batchID}</BatchID>
      </system>`
        .replace(/\s+/g, '')
        .replace(/<data_set><\/data_set>/g, `<data_set>${this.marketingCloud_dataset}</data_set>`)
    }
  },

  // Methods
  methods: {
    /**
     * Marketing Cloud: Set Cookies
     * Loops through the object of keys/values, setting any that are found in the URL as a cookie
     */
    $_marketingCloud_setCookies () {
      const url = new URL(window.location.href)
      for (let [key, value] of Object.entries(this.marketingCloud_values)) {
        const urlParamValue = url.searchParams.get(key)
        if (urlParamValue) {
          const expireDate = new Date()
          expireDate.setDate(new Date().getDate() + this.marketingCloud_expireDays)
          this.$_cookies_setItem(value, urlParamValue, expireDate)
        }
      }
    },

    /**
     * Marketing Cloud: Create Tracking Pixel
     * Creates an <img/> element, sets appropriate attributes, and appends it to the document body
     */
    $_marketingCloud_createTrackingPixel () {
      const trackingPixel = document.createElement('img')
      trackingPixel.setAttribute('src', this.$_marketingCloud_pixelSrc)
      trackingPixel.setAttribute('width', 1)
      trackingPixel.setAttribute('height', 1)
      trackingPixel.style.display = 'none'
      document.body.appendChild(trackingPixel)
    }

  }
}
